import React, { useEffect, useRef, useState } from "react"
import {
  Box,
  Button,
  FormControl,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Backdrop,
  CircularProgress,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { t } from "i18next"
import { useParams, useSearchParams } from "react-router-dom"
import ExpandMoreFilled from "@mui/icons-material/ExpandMore"
import { flushSync } from "react-dom"
import { fetchRefinementZipFile } from "@/core/app/slices/clinical/refinement/refinementThunkApi"
import {
  caseManagement,
  treatView,
  viewControlInTreatment,
  initialfinal,
} from "@/gluelayer"
import { refinementModule } from "@/gluelayer/core/modules/refinement"
import {
  setRefinementNum,
  setOpenHistorySplitView,
  setStageShowType,
  setStageCompareLoadData,
  // setGoAutoProcesses,
  // setopenGrid,
  // setopenInitialFinal,
  setIsCreateNewRefinement,
  // setIsCreateSelfplanRefinement,
  setSelectTxDataSave,
  setSelectTxButton,
  setShouldCloseTab,
  setStageCompareLeftViewRefinementIndex,
  setCurrentRefinementName,
} from "../udTreatSlice"
import FullscreenIcon from "../../../src/assets/images/FullscreenIcon.svg"
import FullscreenExitIcon from "../../../src/assets/images/FullscreenExitIcon.svg"
import CloseIcon from "../../../src/assets/images/closeIcon.svg"

import { useMyNavigation } from "@/hooks/useMyNavigation"
import ulablogo from "../../../src/assets/images/uLab_Logo.webp"
import { ReactSVG } from "react-svg"
import DialogBox from "@/modules/Clinical/components/DialogBox/dialogBox"
import { UButton } from "@/components/index"
import { set } from "react-hook-form"
import { userSelectTxChangeSave } from "../bottom/StageBar/stageCommon"
import { safeCloseWindow } from "@/core/app/CloseTabContext"
import { cancelRefine } from "@/gluelayer/core/modules/sagemaker/presetup"
import { cleanRefinementZips } from "../../core/app/slices/clinical/clinicalSlice"
import faq from "../../../src/assets/images/helpicon.svg"
import ProfileOptions from "@/containers/MainLayout/Header/ProfileOptions"
import Shortcuts from "@/modules/Help/help/Shortcuts"
import ZoomSettings from "@/modules/Help/help/ZoomSettings"
import { useTranslation } from "react-i18next"
import { fetchFormLists } from "@/core/app/slices/uassist/formThunkApi"
import { fetchWorkflowSettings } from "@/core/app/slices/user/userApis"
import { dateFormat } from "@/core/utils/formatters"

let curRefinementZipFolderNames: string[]
let curSelectedRefinement: string = ""
let curSelectedRefinementData: string = ""

const ClinicalHeader: React.FC = (prop: any) => {
  const dispatch = useAppDispatch()

  const [frontPhoto, setFrontPhoto] = useState()
  const [showHistoryList, setShowHistoryList] = useState(false)

  const [photoURL, setPhotoURL] = useState<string>()

  const [openRefDialog, setOpenRefDialog] = useState<boolean>(false)

  const { profile } = useAppSelector((state: RootState) => state.xrayService)

  const [historyList, setHistoryList] = useState([])
  const [oriCreateDate, setOriCreateDate] = useState("")
  const [currentRefinement, setCurrentRefinement] = useState({
    name: "",
    date: "",
  })
  const [lastRefinement, setLastRefinement] = useState({ name: "", date: "" })
  const [showSplitCloseBtn, setShowSplitCloseBtn] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showDropdownBtn, setShowDropdownBtn] = useState(false)
  const [showCreateRefinementType, setShowCreateRefinementType] =
    useState(false)

  const { refinementReady } = useAppSelector(
    (state: RootState) => state.clinicalService,
  )

  const { refinementZips } = useAppSelector(
    (state: RootState) => state.clinicalService,
  )
  const {
    user: { current_orgId },
  } = useAppSelector((state: RootState) => state.userService)
  const {
    stageCompareLoadData,
    isCreateNewRefinement,
    // goAutoProcesses,
    switchViewEdit,
    isOpenModelCheck,
    openStlPrint,
    startAutoModelCheck,
    isDoingPresetup
  } = useAppSelector((state: RootState) => state.udTreatService)
  const { patientData } = useAppSelector(
    (state: RootState) => state.patientService,
  )
  const { caseId, patientId } = useParams()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const navigate = useMyNavigation()

  const {
    patientData: { firstName = "", lastName = "" },
  } = useAppSelector((state: RootState) => {
    return state.patientService
  })
  const [searchParams, setSearchParams] = useSearchParams()

  const { user } = useAppSelector((state: RootState) => state.userService)

  const [full, setFull] = useState<boolean>(false)
  const [isHelpOpen, setIsHelpOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [isProfileOpen, setIsProfileOpen] = useState(false)
  const { t } = useTranslation("common")
  const [showShortcutPopup, setShowShortcutPopup] = useState(false)
  const [zoomSettingsPopup, setZoomSettingsPopup] = useState(false)
  const helpMenuItems = [
    {
      name: t("header.helpMenu.help"),
      onClick: () => {
        setIsHelpOpen(false)
        window.open("/help/help")
      },
    },
    {
      name: t("header.helpMenu.shortcuts"),
      onClick: () => {
        setIsHelpOpen(false)
        setShowShortcutPopup(true)
      },
    },
    {
      name: t("header.helpMenu.releaseNotes"),
      onClick: () => {
        window.open("/help/releaseNotes")
        setIsHelpOpen(false)
      },
    },
    {
      name: t("header.helpMenu.adjustZoomSettings"),
      onClick: () => {
        setIsHelpOpen(false)
        setZoomSettingsPopup(true)
      },
    },
  ]

  const handleMenuClose = () => {
    setAnchorEl(null)
    setIsProfileOpen(false)
    setIsHelpOpen(false)
  }

  useEffect(()=>{
    //切换refinement时更新report pdf中的日期
    //when switching refinement, update the date in the report pdf
    dispatch(setCurrentRefinementName(currentRefinement.name))
  },[currentRefinement])

  const clickFull = () => {
    if (!full) {
      const docElm = document.documentElement
      /*W3C*/
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } /*FireFox */ else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } /*Chrome等 */ else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      } /*IE11*/ else if (docElm.msRequestFullscreen) {
        docElm.msRequestFullscreen()
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
    setFull(!full)
  }

  const onClickSaveCase = (e, isViewMode?: boolean) => {
    prop.onclickCloseBtn(() => {
      if (!switchViewEdit && isViewMode) {
        safeCloseWindow()
        return
      }

      let path = "/patients"
      const from = searchParams.get("from")
      if (from === "bundle" || location.hash === "#uassist") {
        console.log("location :", location.hash)
        path = "/patients"
      }
      // if (goAutoProcesses) {
      //   path = "/patients"
      //   dispatch(setGoAutoProcesses(false))
      // }
      navigate(path)
    })
  }

  const creatDate = caseDetail.createDate
    ? `${dateFormat(caseDetail.createDate, "MM/DD/YY")}`
    : ""

  useEffect(() => {
    return () => {
      dispatch(setRefinementNum(0))
      dispatch(cleanRefinementZips())
      curSelectedRefinement = ""
      curSelectedRefinementData = ""
    }
  }, [])

  useEffect(() => {
    dispatch(fetchFormLists())
    dispatch(fetchWorkflowSettings())
  }, [dispatch, user.current_orgId])

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const refinementReadyRef = useRef(refinementReady)
  refinementReadyRef.current = refinementReady

  useEffect(() => {
    if (
      creatDate !== "" &&
      caseManagement.isCaseInit() &&
      refinementReadyRef.current
    ) {
      setShowDropdownBtn(true)
      setOriCreateDate(creatDate)
      const refinementHistoryList = refinementModule.getRefinementDateInfo()
      const orgId = current_orgId

      const firstKey = Object.keys(refinementHistoryList)[0]
      if (firstKey && refinementHistoryList[firstKey] !== "") {
        setCurrentRefinement({
          name: firstKey,
          date: refinementHistoryList[firstKey],
        })
        setLastRefinement({
          name: firstKey,
          date: refinementHistoryList[firstKey],
        })

        dispatch(setCurrentRefinementName(firstKey))
      } else {
        setCurrentRefinement({ name: "initial plan", date: creatDate })
        setLastRefinement({ name: "initial plan", date: creatDate })
        dispatch(setCurrentRefinementName("original"))
      }

      const tempList = []
      for (const item in refinementHistoryList) {
        if (item !== "original")
          tempList.push({
            name: item,
            date:
              refinementHistoryList[item] !== ""
                ? refinementHistoryList[item]
                : creatDate,
          })
      }
      tempList.push({ name: "initial plan", date: creatDate })
      setHistoryList([...tempList])
      dispatch(setRefinementNum(tempList.length))
      console.log("refinementHistoryList", tempList)
    }
  }, [creatDate, caseManagement.isCaseInit(), refinementReadyRef.current])

  useEffect(() => {
    if (Object.keys(refinementZips).length > 0 && showHistoryList) {
      caseManagement
        .AddARefinementHistory(
          curRefinementZipFolderNames,
          refinementZips as Record<string, Blob>,
        )
        .then(() => {
          openRefinementHistory(
            curSelectedRefinement,
            curSelectedRefinementData,
          )
        })
    }
  }, [refinementZips])

  const openRefinementHistory = async (name, date) => {
    const historyName = name === "initial plan" ? "original" : name
    if (currentRefinement.name === lastRefinement.name) {
      treatView.Open(true)
      treatView.RefinementHistory(historyName)
      treatView.SetBackgroundPicture(1, "backgroundvtk.png")
      dispatch(setOpenHistorySplitView(true))
    } else {
      treatView.SwitchRefinementHistory(historyName)
    }
    setShowHistoryList(false)
    setShowSplitCloseBtn(true)
    setCurrentRefinement({ name, date })
    flushSync(() => setIsLoading((pre) => !pre))
    const refineIndexStrArray = historyName.match(/\d+/g)
    const refineIndexStr = refineIndexStrArray ? refineIndexStrArray[0] : ""
    const refineIndex =
      refineIndexStr.length <= 0 ? 0 : parseInt(refineIndexStr)
    dispatch(setStageCompareLeftViewRefinementIndex(refineIndex))
    dispatch(setStageShowType("compare"))
    dispatch(setStageCompareLoadData(!stageCompareLoadData))
    viewControlInTreatment.setViewType("front")
    viewControlInTreatment.hoverToothToggle(false)
    viewControlInTreatment.setSpacecheckVisibility(false)
    viewControlInTreatment.setOcclusionVisibility(false)
    viewControlInTreatment.setSuperimposeVisibility(false)
    viewControlInTreatment.setGridVisibility(false)
    initialfinal.setInitialFinalEnabled(false)
  }

  const historyItemClick = (name, date) => {
    const wasmName = name === "initial plan" ? "original" : name
    if (name === lastRefinement.name && name === currentRefinement.name) {
      flushSync(() => setIsLoading((pre) => !pre))
      return
    }
    if (name === lastRefinement.name) {
      treatView.Open(false)
      dispatch(setStageShowType("normal"))
      dispatch(setOpenHistorySplitView(false))
      setShowSplitCloseBtn(false)
      setCurrentRefinement({
        name: lastRefinement.name,
        date: lastRefinement.date,
      })
      setShowHistoryList(false)
      flushSync(() => setIsLoading((pre) => !pre))
      return
    }
    const folderNames = refinementModule.getDownloadDataNames(wasmName)

    curRefinementZipFolderNames = []
    let refinementFiles = []
    let AllExisted = true
    for (let j = 0; j < folderNames.size(); j++) {
      const folderName = folderNames.get(j)

      const isExisted = caseManagement.IsRefinementItemExisted(folderName)
      if (isExisted == false) {
        curRefinementZipFolderNames.push(folderName)
        refinementFiles.push(folderName + ".zip")
        AllExisted = false
      }
    }

    if (AllExisted == true) {
      openRefinementHistory(name, date)
    } else {
      curSelectedRefinement = name
      curSelectedRefinementData = date

      dispatch(
        fetchRefinementZipFile({
          orgId: "",
          patientId,
          caseId,
          refinementFiles,
        }),
      )
    }
  }

  const HistoryItem = ({ id, name, date }) => {
    return (
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: name === lastRefinement.name ? "#9C9C9C" : "#000",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: "400",
            letterSpacing: "0.46px",
            marginTop: "7px",
            marginBottom: "7px",
            marginLeft: "15px",
            display: "inline-block",
            width: "auto",
            "&:hover": {
              cursor: "pointer",
            },
          }}
          onClick={async () => {
            flushSync(() => setIsLoading((pre) => !pre))
            await new Promise((resolve) => setTimeout(resolve, 0))
            if (
              name === lastRefinement.name &&
              name === currentRefinement.name
            ) {
              flushSync(() => setIsLoading((pre) => !pre))
              return
            }
            const isTxDataChanged = caseManagement.getTxDataChanged()
            //check the stage data is changed or not
            if (switchViewEdit && isTxDataChanged) {
              flushSync(() => setIsLoading(false))
              dispatch(setSelectTxButton(1))
              dispatch(setSelectTxDataSave("save_show"))
              userSelectTxChangeSave().then((result) => {
                if (result === "save_cancel") {
                  return
                }
                flushSync(() => setIsLoading(true))
                historyItemClick(name, date)
              })
            } else {
              historyItemClick(name, date)
            }
            // historyItemClick(name, date)
          }}
        >
          {` #` + id + " | " + capitalizeFirstLetter(name) + " - " + date}
        </Typography>
        {/* <Launch
            sx={{
              display: "inline-block",
              position: "absolute",
              right: "15px",
              marginTop: "9px",
              width: 20,
              height: 20,
              color: id === caseId ? "#9C9C9C" : "#000",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          ></Launch> */}
      </Box>
    )
  }
  const HistoryListForm = () => {
    return (
      <FormControl
        sx={{
          width: "331px",
          position: "absolute",
          top: "calc(100% + 8px)",
          left: 140,
          zIndex: 1000,
          background: "white",
          paddingBottom: 1,
          paddingTop: 1,
          borderRadius: "4px",
          boxShadow: 5,
        }}
      >
        {historyList.map((item, index) => {
          return (
            <HistoryItem
              key={"history-item-" + index}
              id={caseId}
              name={item.name}
              date={item.date}
            />
          )
        })}
        {/* <Typography
          variant="caption"
          sx={{
            color: "#16AADC",
            fontFamily: "Poppins",
            fontSize: "14px",
            fontWeight: "550",
            textTransform: "uppercase",
            letterSpacing: "0.46px",
            marginTop: "12px",
            marginBottom: "12px",
            marginLeft: "15px",
            display: "inline-block",
            width: "auto",
            "&:hover": {
              cursor: "pointer",
            },
          }}
          onClick={() => {
            const isTxDataChanged = caseManagement.getTxDataChanged()
            //check the stage data is changed or not
            if (switchViewEdit && isTxDataChanged) {
              dispatch(setSelectTxButton(1))
              dispatch(setSelectTxDataSave("save_show"))
              userSelectTxChangeSave().then((result) => {
                if (result === "save_cancel") {
                  return
                }
                setShowCreateRefinementType(true)
              })
            } else {
              setShowCreateRefinementType(true)
            }
            //setShowCreateRefinementType(true)
          }}
        >
          Add new refinement
        </Typography> */}
      </FormControl>
    )
  }

  const closeHistoryCompare = () => {
    treatView.Open(false)
    setShowSplitCloseBtn(false)
    dispatch(setStageShowType("normal"))
    dispatch(setOpenHistorySplitView(false))
    setCurrentRefinement({
      name: lastRefinement.name,
      date: lastRefinement.date,
    })
  }

  return (
    <Box
      sx={{
        left: 0,
        top: 0,
        right: 0,
        height: "40px",
        backgroundColor: "white",
        justifyContent: "center",
        position: "absolute",
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          height: "100%",
        }}
        paddingLeft={2}
        paddingRight={2}
      >
        <Box
          sx={{
            marginLeft: "12px",
          }}
        >
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Box
              component={"img"}
              src={ulablogo}
              alt={"Logo"}
              // loading="lazy"
              sx={{ mb: 3, width: "77px", height: "32px" }}
            />
            <Box
              component="div"
              sx={{
                borderLeft: "1px solid #000000",
                opacity: "0.12",
                height: "35px",
                mx: 2,
              }}
            ></Box>
            <Typography
              sx={{
                color: "var(--grey-600, #757575)",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: "Poppins",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "32px",
                letterSpacing: "0.15px",
              }}
              color={"gray"}
            >
              uDesign Cloud
            </Typography>
          </Stack>
        </Box>

        <Stack
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            height: "40px",
            display: isCreateNewRefinement ? "none" : "",
            alignItems: "center",
            flexGrow: 1,
            zIndex: 1000,
          }}
          direction={"row"}
          spacing={4}
        >
          <Tooltip
            arrow
            title={
              <span>
                <strong>{t("records.tooltipNotesLabel")}</strong>{" "}
                {patientData.notes}
              </span>
            }
            placement="right"
            followCursor
            disableHoverListener={
              patientData.notes === null || patientData.notes.trim() === ""
            }
          >
            <Typography
              sx={{
                color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: "Poppins",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "26px",
                letterSpacing: "0.46px",
                textTransform: "uppercase",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              {firstName + " " + lastName}
            </Typography>
          </Tooltip>

          <Box>
            <Typography
              variant="caption"
              sx={{
                color: "var(--text-secondary, rgba(0, 0, 0, 0.60))",
                fontFeatureSettings: "'liga' off, 'clig' off",
                fontFamily: "Poppins",
                fontSize: "15px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "26px",
                letterSpacing: "0.46px",
              }}
            >
              {showDropdownBtn
                ? ` #` +
                  caseId +
                  " | " +
                  currentRefinement.name +
                  " - " +
                  currentRefinement.date
                : `#${caseId}`}
            </Typography>
            {showDropdownBtn && !isDoingPresetup && (
              <IconButton
                aria-label="more"
                sx={{
                  width: 28,
                  height: 28,
                  transform: showHistoryList ? "scaleY(-1)" : "scaleY(1)",
                  visibility:
                    isOpenModelCheck || startAutoModelCheck || openStlPrint
                      ? "hidden"
                      : "visible",
                }}
                onClick={() => {
                  setShowHistoryList(!showHistoryList)
                }}
              >
                <ExpandMoreFilled sx={{ color: "#5A5A5A" }} />
              </IconButton>
            )}
            {showHistoryList && <HistoryListForm />}
          </Box>
        </Stack>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            textAlign: "right",
            gap: "4px",
          }}
        >
          <Box
            component="img"
            src={full ? FullscreenExitIcon : FullscreenIcon}
            onClick={clickFull}
            sx={{
              color: "#757575",
              cursor: "pointer",
              width: 32,
              height: 32,
              p: 0.5, //  padding: "4px"
            }}
          />

          <Box
            data-testid={"faqIcon"}
            component={"img"}
            src={faq}
            alt={"Logo"}
            onClick={(e) => {
              setIsHelpOpen(!isHelpOpen)
              setAnchorEl(e.currentTarget)
            }}
            loading="lazy"
            sx={{ cursor: "pointer", width: "32px", height: "32px", p: 0.5 }}
          />

          <Box
            component={"img"}
            src={CloseIcon}
            alt={"close"}
            sx={{
              backgroundColor: "transparent",
              width: "32px",
              height: "32px",
              p: 0.5,
              display:
                openStlPrint || isOpenModelCheck || startAutoModelCheck
                  ? "none"
                  : "",
              cursor: "pointer",
            }}
            aria-label="settings"
            onClick={(e) => {
              const udesign_json = JSON.parse(caseDetail.udesign_json)
              // if (udesign_json && udesign_json.isDoingRefinePresetup) {
              //   cancelRefine()
              // }
              const isTxDataChanged = caseManagement.getTxDataChanged()
              //check the stage data is changed or not, if changed, save it by user selection, else close case
              if (switchViewEdit && isTxDataChanged) {
                dispatch(setSelectTxButton(1))
                dispatch(setSelectTxDataSave("save_show"))
                userSelectTxChangeSave().then((result) => {
                  if (result === "save_cancel") {
                    dispatch(setShouldCloseTab(false))
                    return
                  }
                  dispatch(setShouldCloseTab(true))
                  onClickSaveCase(e)
                })
              } else {
                dispatch(setShouldCloseTab(true))
                onClickSaveCase(e, true)
              }
            }}
          />
        </Box>
      </Stack>

      {showSplitCloseBtn && (
        <Button
          aria-label="close"
          onClick={closeHistoryCompare}
          sx={{
            background: (theme) => theme.palette.grey[300],
            position: "absolute",
            left: "calc(46.5% - 40px)",
            top: 100,
            width: "81px",
            height: "48px",
            borderRadius: 6,
            boxShadow: 4,
            color: "black",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.grey[500],
            },
          }}
        >
          Close
        </Button>
      )}

      <ProfileOptions
        handleOnClose={handleMenuClose}
        menuProps={{
          ".MuiPaper-root": {
            minWidth: "220px",
          },
        }}
        menuItems={helpMenuItems}
        anchorEl={anchorEl}
        isOpen={isHelpOpen}
      />
      <Shortcuts
        isOpen={showShortcutPopup}
        onClose={() => {
          setShowShortcutPopup(false)
        }}
      />
      <ZoomSettings
        isOpen={zoomSettingsPopup}
        onClose={() => {
          setZoomSettingsPopup(false)
        }}
      />
      <DialogBox
        open={showCreateRefinementType}
        title="Submit new refinement"
        content={<>{"Select the type of new refinement"}</>}
        actions={
          <>
            <UButton
              onClickHandler={() => {
                setShowCreateRefinementType(false)
              }}
              variant={"text"}
              btnText={"cancel"}
            />
            <UButton
              onClickHandler={() => {
                setShowCreateRefinementType(false)
                setShowHistoryList(false)
                // flushSync(() => dispatch(setopenInitialFinal(false)))
                // flushSync(() => dispatch(setopenGrid(false)))
                treatView.startSplitScreenToCreateRefinement()
                dispatch(setIsCreateNewRefinement(true))
                dispatch(setStageShowType("compare"))
              }}
              variant={"outlined"}
              btnText={"UAssist"}
            />
            <UButton
              onClickHandler={() => {
                setShowCreateRefinementType(false)
                setShowHistoryList(false)
                // flushSync(() => dispatch(setopenInitialFinal(false)))
                // flushSync(() => dispatch(setopenGrid(false)))
                treatView.startSplitScreenToCreateRefinement()
                dispatch(setIsCreateNewRefinement(true))
                // dispatch(setIsCreateSelfplanRefinement(true))
                dispatch(setStageShowType("compare"))
              }}
              variant={"outlined"}
              btnText={"Selfplan"}
            />
          </>
        }
      ></DialogBox>
      <Backdrop
        sx={{
          backgroundColor: "transparent",
          zIndex: (theme) => theme.zIndex.modal + 10,
        }}
        open={isLoading}
      >
        <CircularProgress key={isLoading ? "open" : "closed"} />
      </Backdrop>
    </Box>
  )
}

export default ClinicalHeader
